export default __webpack_public_path__ + "static/assets/1cb9ea4b40f6b1fc864deae959a7a3db.png";